/** Klassennamen zusammensetzen; falsche Werte werden verworfen. */
export function cn(...teile: Array<string | false | null | undefined>): string {
  return teile.filter(Boolean).join(' ');
}
